import React from 'react';
import { AlertCircle, Users, UserCheck, DollarSign, History, Settings, Wallet } from 'lucide-react';

export type TabType = 'alerts' | 'staff' | 'clients' | 'financial' | 'payroll' | 'history' | 'settings';

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  alertCount: number;
  historyCount?: number;
}

export function TabNavigation({ activeTab, onTabChange, alertCount, historyCount }: TabNavigationProps) {
  const tabs: { id: TabType; label: string; icon: React.ElementType; badge?: number }[] = [
    { id: 'alerts', label: 'Alerts', icon: AlertCircle, badge: alertCount },
    { id: 'staff', label: 'Staff', icon: Users },
    { id: 'clients', label: 'Clients', icon: UserCheck },
    { id: 'financial', label: 'Financial', icon: DollarSign },
    { id: 'payroll', label: 'Payroll', icon: Wallet },
    { id: 'history', label: 'History', icon: History, badge: historyCount },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  return (
    <div className="border-b border-slate-700 bg-slate-800/30">
      <nav className="flex overflow-x-auto scrollbar-hide">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`relative flex items-center justify-center gap-1.5 sm:gap-2 px-3 sm:px-5 py-3 sm:py-3.5 text-xs sm:text-sm font-medium transition-all whitespace-nowrap flex-1 sm:flex-none min-w-0 ${
              activeTab === tab.id
                ? 'text-blue-400'
                : 'text-slate-400 hover:text-slate-200 hover:bg-slate-700/30'
            }`}
          >
            {/* Active indicator */}
            {activeTab === tab.id && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-500 rounded-t-full" />
            )}
            
            <tab.icon className={`w-4 h-4 flex-shrink-0 ${activeTab === tab.id ? 'text-blue-400' : ''}`} />
            <span className="hidden sm:inline truncate">{tab.label}</span>
            
            {/* Badge */}
            {tab.badge !== undefined && tab.badge > 0 && (
              <span className={`flex-shrink-0 min-w-[18px] h-[18px] sm:min-w-[20px] sm:h-[20px] flex items-center justify-center text-[10px] sm:text-xs font-bold rounded-full ${
                tab.id === 'alerts' 
                  ? 'bg-red-500 text-white' 
                  : 'bg-slate-600 text-slate-200'
              }`}>
                {tab.badge > 99 ? '99+' : tab.badge}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}
